/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Wrapper for a facet.
 * @export
 * @interface Facet
 */
export interface Facet {
    /**
     * Node id or String id
     * @type {string}
     * @memberof Facet
     */
    id: string;
    /**
     * Label of the filter
     * @type {string}
     * @memberof Facet
     */
    label: string;
    /**
     * Count of hits
     * @type {number}
     * @memberof Facet
     */
    count: number;
}

export function FacetFromJSON(json: any): Facet {
    return FacetFromJSONTyped(json, false);
}

export function FacetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Facet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'count': json['count'],
    };
}

export function FacetToJSON(value?: Facet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'count': value.count,
    };
}

